<div class="app-radio-group">
  <ng-content></ng-content>
</div> 